<template>
  <screen-locker>
    <template v-slot:content>
      <div
        class="page page-extra-protection d-flex flex-column"
        v-if="!showLoadingNextStep"
      >
        <AppHeader :step-active="4"></AppHeader>
        <div class="row header-page">
          <div class="col">
            <h3>Proteggi anche il tuo mondo con le tutele aggiuntive</h3>
            <div class="row h-100">
              <div class="col h-100">
                <div
                  class="banner banner-extra-protection banner-description h-100"
                >
                  <div class="row">
                    <div class="col-12 position-absolute">
                      <div
                        class="svg-banner-extra-protections w-100 h-100 d-flex align-items-center"
                        v-bind:class="getBannerClasses()"
                      >
                        <svg-viewer
                          :src="
                            window.width <= 1440
                              ? require('../assets/images/banner/01-main.svg')
                              : require('../assets/images/banner/01-wide.svg')
                          "
                          width="100%"
                          :height="window.width <= 1440 ? '350px' : '430px'"
                        ></svg-viewer>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      Scegliendo i servizi aggiuntivi Tutela dai a chi ami la
                      serenità per affrontare il futuro. Un aiuto economico
                      concreto che puoi attivare in modo semplice ed efficace.
                      <div class="mt-3">
                        <b-button @click="showModal()" class="btn-red"
                          >Scopri di più</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-data mt-3" style="min-height: 140px">
          <div class="col mt-3">
            <div class="d-flex">
              <add-coverage-selector
                v-for="(item, index) in extraProtectionList"
                :key="index"
                :title="item.title"
                :multiplier="item.multiplier"
                :sum-all-coverage="sumCoverages"
                :max-value="maxValue"
                :list-values="item.listValues"
                :disabled="item.disabled"
                v-model="item.model"
              ></add-coverage-selector>
              <div v-if="extraProtectionList.length === 0">
                Non è possibile attivare coperture aggiuntive
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex footer-page">
          <b-button variant="link" @click="back()">
            <img alt="Indietro" src="../assets/images/back.svg" />
            Indietro
          </b-button>
          <b-button
            variant="primary ml-auto"
            :disabled="disabledNextStep()"
            @click="processData()"
            >Avvia</b-button
          >
        </div>
      </div>
      <b-modal
        v-model="modal"
        adaptive="true"
        title="GSS"
        dialog-class="modal-full"
        hide-footer
      >
        <template v-slot:modal-header>
          &nbsp;
          <b-button
            variant="link modal-close"
            size="sm"
            class="float-right"
            @click="modal = false"
          >
            <img src="../assets/images/close.svg" alt="Chiudi" />
          </b-button>
        </template>
        <b-container style="height: 80vh">
          <extra-protection-info />
        </b-container>
      </b-modal>
      <loading-page
        v-if="showLoadingNextStep"
        :timeout="2000"
        show-class="show-spin-01"
        destination="scenario"
      ></loading-page>
    </template>
    <auth-guard />
  </screen-locker>
</template>

<script>
import router from "../router";
import AddCoverageSelector from "../components/AddCoverageSelector";
import { engineService } from "../services/engine.service";
import { ExtraProtectionData } from "../data/extra-protection.data";
import ExtraProtectionInfo from "./modals/ExtraProtectionInfo";
import LoadingPage from "../components/LoadingPage";
export default {
  name: "ExtraProtection",
  components: { LoadingPage, ExtraProtectionInfo, AddCoverageSelector },
  data: () => {
    return {
      val: false,
      modal: false,
      maxValue: 0,
      sumCoverages: 0,
      extraProtectionList: [],
      window: {
        width: 0,
        height: 0
      },
      showLoadingNextStep: false
    };
  },
  created() {
    this.extraProtectionList = JSON.parse(JSON.stringify(ExtraProtectionData));
    this.extraProtectionList.forEach(e => {
      if (
        e.id === 3 && // family care
        (this.$store.state.ageValue === "66-80" ||
          !this.$store.state.generaliPlusValue)
      )
        e.disabled = true;

      if (
        e.id === 2 && // acma is
        (this.$store.state.ageValue === "66-80" ||
          this.$store.state.generaliPlusValue)
      )
        e.disabled = true;

      if (
        e.id === 1 && // tmc
        (this.$store.state.ageValue === "66-80" ||
          this.$store.state.ageValue === "41-65")
      )
        e.disabled = true;
    });
    this.extraProtectionList.filter(a => {
      if (
        this.$store.state.extraProtectionValue.filter(e => e.id === a.id)
          .length > 0
      ) {
        a.model.selected = true;
        a.model.value = this.$store.state.extraProtectionValue.filter(
          e => e.id === a.id
        )[0].value;
      }
    });
    this.maxValue = this.$store.state.capitalValue * 3;
    this.sumCoverages = this.extraProtectionList
      .filter(e => e.selected)
      .reduce((a, b) => a + b, 0);
    this.extraProtectionList.filter(e => {
      if (e.id === 1) {
        // TMC
        e.listValues = engineService.getComplementaryCapitalsList(
          this.$store.state.capitalValue
        );
        // console.log("e.listValues", e.listValues);
        if (
          typeof e.model.value === "undefined" ||
          e.model.value === null ||
          e.model.value === 0
        ) {
          e.model.value = e.listValues[0];
        }
      }
      if (e.id === 2) {
        // ACMA IS
        e.listValues = engineService.getComplementaryCapitalsList(
          this.$store.state.capitalValue
        );
        if (
          typeof e.model.value === "undefined" ||
          e.model.value === null ||
          e.model.value === 0
        ) {
          e.model.value = e.listValues[0];
        }
      }
      if (e.id === 3) {
        // FamilyCare
        e.listValues = engineService.getComplementaryCapitalsList(
          this.$store.state.capitalValue
        );
        if (
          typeof e.model.value === "undefined" ||
          e.model.value === null ||
          e.model.value === 0
        ) {
          e.model.value = e.listValues[0];
        }
      }
    });
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  watch: {
    extraProtectionList: {
      deep: true,
      handler(after) {
        this.sumCoverages = after
          .filter(e => e.model.selected)
          .reduce(
            (a, b) =>
              (isNaN(a) ? a.model.value : a) + (isNaN(b) ? b.model.value : b),
            0
          );
      }
    }
  },
  methods: {
    showModal() {
      this.modal = true;
    },
    disabledNextStep() {
      return false;
    },
    processData() {
      // console.log("STORE", this.$store.state);
      if (!this.disabledNextStep()) {
        this.saveState();
        this.saveSaveScenarioResults();
        this.showLoadingNextStep = true;
        // router.push("/scenario");
      }
    },
    saveState() {
      this.$store.commit("setExtraProtectionValue", []);
      this.$store.commit(
        "setExtraProtectionValue",
        this.extraProtectionList
          .filter(a => a.model.selected)
          .map(a => {
            return {
              id: a.id,
              value: a.model.value
            };
          })
      );
    },
    saveSaveScenarioResults() {
      const stress = engineService.runSimulation("stressato");
      const prestazioneTotaleStress = [];
      const totaleMorteStress = [];
      const riscattoStress = [];
      const familyCareStress = [];
      const acmaisStress = [];
      const mortePUStress = [];
      const morteStress = [];

      stress.data.filter(r => {
        prestazioneTotaleStress.push(r.prestazioneTotale);
        totaleMorteStress.push(r.totaleMorte);
        riscattoStress.push(r.riscatto);
        familyCareStress.push(r.familyCare);
        acmaisStress.push(r.acma);
        mortePUStress.push(r.mortePU);
        morteStress.push(r.morte);
      });

      const unfavorable = engineService.runSimulation("sfavorevole");
      const prestazioneTotaleUnfavorable = [];
      const totaleMorteUnfavorable = [];
      const riscattoUnfavorable = [];
      const familyCareUnfavorable = [];
      const acmaisUnfavorable = [];
      const mortePUUnfavorable = [];
      const morteUnfavorable = [];

      unfavorable.data.filter(r => {
        prestazioneTotaleUnfavorable.push(r.prestazioneTotale);
        totaleMorteUnfavorable.push(r.totaleMorte);
        riscattoUnfavorable.push(r.riscatto);
        familyCareUnfavorable.push(r.familyCare);
        acmaisUnfavorable.push(r.acma);
        mortePUUnfavorable.push(r.mortePU);
        morteUnfavorable.push(r.morte);
      });

      const moderate = engineService.runSimulation("moderato");
      const prestazioneTotaleModerate = [];
      const totaleMorteModerate = [];
      const riscattoModeratee = [];
      const familyCareModerate = [];
      const acmaisModerate = [];
      const mortePUModerate = [];
      const morteModerate = [];

      moderate.data.filter(r => {
        prestazioneTotaleModerate.push(r.prestazioneTotale);
        totaleMorteModerate.push(r.totaleMorte);
        riscattoModeratee.push(r.riscatto);
        familyCareModerate.push(r.familyCare);
        acmaisModerate.push(r.acma);
        mortePUModerate.push(r.mortePU);
        morteModerate.push(r.morte);
      });

      const favorable = engineService.runSimulation("favorevole");
      const prestazioneTotaleFavorable = [];
      const totaleMorteFavorable = [];
      const riscattoFavorable = [];
      const familyCareFavorable = [];
      const acmaisFavorable = [];
      const mortePUFavorable = [];
      const morteFavorable = [];

      favorable.data.filter(r => {
        prestazioneTotaleFavorable.push(r.prestazioneTotale);
        totaleMorteFavorable.push(r.totaleMorte);
        riscattoFavorable.push(r.riscatto);
        familyCareFavorable.push(r.familyCare);
        acmaisFavorable.push(r.acma);
        mortePUFavorable.push(r.mortePU);
        morteFavorable.push(r.morte);
      });

      const scenarios = [
        {
          type: "favorevole",
          finalPerformanceArr: prestazioneTotaleFavorable,
          deathTotalArr: totaleMorteFavorable,
          deathArr: [],
          surrenderValueArr: riscattoFavorable,
          deathValueArr: morteFavorable,
          FamilyCareExtraProtectionValueArr: familyCareFavorable,
          ACMAExtraProtectionValuieArr: acmaisFavorable,
          TCMPUExtraProtectionValueArr: mortePUFavorable,
          tirCostFirstYearValue: favorable.tir.tirCostFirstYearValues,
          tirCostMidYearValue: favorable.tir.tirCostMidYearValues,
          tirCostLastYearValue: favorable.tir.tirCostLastYearValues
        },
        {
          type: "moderato",
          finalPerformanceArr: prestazioneTotaleModerate,
          deathTotalArr: totaleMorteModerate,
          surrenderValueArr: riscattoModeratee,
          deathValueArr: morteModerate,
          FamilyCareExtraProtectionValueArr: familyCareModerate,
          ACMAExtraProtectionValuieArr: acmaisModerate,
          TCMPUExtraProtectionValueArr: mortePUModerate,
          tirCostFirstYearValue: moderate.tir.tirCostFirstYearValues,
          tirCostMidYearValue: moderate.tir.tirCostMidYearValues,
          tirCostLastYearValue: moderate.tir.tirCostLastYearValues
        },
        {
          type: "sfavorevole",
          finalPerformanceArr: prestazioneTotaleUnfavorable,
          deathTotalArr: totaleMorteUnfavorable,
          surrenderValueArr: riscattoUnfavorable,
          deathValueArr: morteUnfavorable,
          FamilyCareExtraProtectionValueArr: familyCareUnfavorable,
          ACMAExtraProtectionValuieArr: acmaisUnfavorable,
          TCMPUExtraProtectionValueArr: mortePUUnfavorable,
          tirCostFirstYearValue: unfavorable.tir.tirCostFirstYearValues,
          tirCostMidYearValue: unfavorable.tir.tirCostMidYearValues,
          tirCostLastYearValue: unfavorable.tir.tirCostLastYearValues
        },
        {
          type: "stressato",
          finalPerformanceArr: prestazioneTotaleStress,
          deathTotalArr: totaleMorteStress,
          surrenderValueArr: riscattoStress,
          deathValueArr: morteStress,
          FamilyCareExtraProtectionValueArr: familyCareStress,
          ACMAExtraProtectionValuieArr: acmaisStress,
          TCMPUExtraProtectionValueArr: mortePUStress,
          tirCostFirstYearValue: stress.tir.tirCostFirstYearValues,
          tirCostMidYearValue: stress.tir.tirCostMidYearValues,
          tirCostLastYearValue: stress.tir.tirCostLastYearValues
        }
      ];
      // console.log("scenarios", scenarios);
      this.$store.commit("setScenarios", scenarios);
    },
    back() {
      router.push("contributions");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getBannerClasses() {
      const result = [];
      let className = "";

      const generaliPiuClass = this.$store.state.generaliPlusValue
        ? "svg-piu-generali"
        : "";
      const generaliBilanciaClass = ""; //this.$store.state.generaliBilanciaValue ? 'svg-add-bilancia readonly' : '';
      className = `svg-${this.$store.state.genderValue.toLocaleLowerCase()}-${
        this.$store.state.ageValue
      } ${generaliPiuClass} ${generaliBilanciaClass}`;
      result.push(className);

      this.extraProtectionList.filter(e => {
        if (e.model.selected) {
          className = `svg-${e.svgClass}`;
          result.push(className);
        }
      });

      return result;
    }
  }
};
</script>
